(function ($) {
	window.addEventListener('load', function () {
		const $liElement = document.querySelector('#wp-admin-bar-new-content > a');

		if (!$liElement) {
			return;
		}

		$liElement.addEventListener('click', function (e) {
			e.preventDefault();
			e.stopPropagation();
			return false;
		});
	});
})();
